/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'overview': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M12 1.5A10.5 10.5 0 112.907 17.25L5.072 16A8 8 0 1012 4z"/><path pid="1" d="M12 8.6a3.4 3.4 0 110 6.8 3.4 3.4 0 010-6.8zM3.99 5.975a1.4 1.4 0 110 2.8 1.4 1.4 0 010-2.8z"/>'
  }
})
